<template>
  <div class="label">
    <div
      v-for="(item, index) in list"
      :key="index"
      v-on:mouseover="showToggle(index)"
      v-on:mouseout="handleHide"
      @click="toMarket(item.path)"
      :class="[
        'sort',
        'mouse',
        NavBar == 1 ? 'NarBarUlColor1' : 'NarBarUlColor2',
      ]"
    >
      <div
        class="title"
        :class="[
          index === isShow ? 'active' : '',
          item.path == path ? 'active' : '',
          language == 'zh' ? 'zhFamily' : 'enfamily',
        ]"
      >
        {{ item.title }}
      </div>
      <!-- index === isShow -->
      <div v-show="index === isShow">
        <div v-for="(item1, idx) in item.list" :key="idx" class="hoverShow">
          <div
            v-on:click="handleHide"
            @click="toMarket(item1.path)"
            :class="[language == 'zh' ? 'zhFamily' : 'enfamily']"
          >
            {{ item1.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMixin } from "@/util/mixin";
export default {
   mixins: [mapMixin],
  props: ["NavBar"],
  mounted() {
    if (window.history && window.history.pushState) {
      window.addEventListener("popstate", this.goBack, false);
    }
    this.path = this.$route.path;
  },
  computed: {
    list() {
      return [
        {
          title: this.$t("Nav.Menu.Home"),
          path: "/",
        },
        {
          title: this.$t("Nav.Menu.DataHub"),
          // path: "/datahub",
           path: "/datahub",
        },
        {
          title: this.$t("Nav.Menu.AppsMarket"),
          //   path: "/appMaket"
          path: "/appMaket",
        },

        {
          title: this.$t("Nav.Menu.Knowledgebase"),
          path: "",
          list: [
            {
              title: this.$t("Nav.Menu.Indicators"),
              path: "/sdgsindicators",
            },
            {
              title: this.$t("Nav.Menu.Reports"),
              path: "/sdgsreports",
            },
          ],
        },
        {
          title: this.$t("Nav.Menu.MySpace"),
          //   path: "/appMaket"
          path: "/private",
        },
       
      ];
    },
  },
  data() {
    return {
      isShow: -1,
      path: null,
    };
  },
  destroyed() {
    window.removeEventListener("popstate", this.goBack, false);
  },
  methods: {
    goBack() {
      this.path = this.$route.path;
    },
    toMarket(path, parentpath) {
      if (path != "") {
        console.log(path);
        if (path == "/sdgsindicators") {
          window.open(path, "_blank");
        } else {
          this.$router.push(path);
          this.path = path;
        }
      }
      // if (parentpath) {
      //   this.path = parentpath;
      // } else {
      //   console.log(1);
      //   this.path = path;
      // }
    },
    showToggle(index) {
      this.isShow = index;
    },
    handleHide() {
      this.isShow = !this.isShow;
    },
    dianji(e) {},
  },
  created() {},
};
</script>
  <style scoped lang="scss">
.zhFamily {
  font-family: $zhFamily;
}
.enfamily {
  font-family: $enFamily;
}
.label {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.active {
  //   color: #000;
  /* background-color: rgba(0, 0, 0, 0.3); */
  background-size: 50% 4px !important;
}
.title {
  background-image: linear-gradient(#fff, #fff);
  background-position: center bottom;
  background-repeat: no-repeat;
  transition: background-size 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53);
  text-decoration: none;
  height: 30px;
  font-size: 14px;
  white-space:nowrap;
  background-size: 0 4px;
  // padding: 0 12px;
  margin: 0 12px;
  box-sizing: border-box;
  text-align: center;
}
.sort:last-child {
  // width: 130px;
}
.sort:nth-child(3) {
  // width: 120px;
}
.title:hover {
  cursor: pointer;
}
.hoverShow {
  cursor: pointer;
  //   width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.hoverShow div {
  text-align: center;
  width: 100%;
  z-index: 99999;
  height: 60px;
  line-height: 60px;
  // padding: 0 6px;
  box-sizing: border-box;
  font-size: 14px;
}
// .hoverShow div:hover {
//   background: rgba(0, 0, 0, 0.6);
// }
.NarBarUlColor1 {
  .title {
    color: #fff;
    background-image: linear-gradient(#fff, #fff);
  }
  .hoverShow div {
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    &:hover {
      background: rgba(0, 0, 0, 0.6);
      //   opacity: .8;
    }
  }
}
.NarBarUlColor2 {
  .title {
    color: #000;
    background-image: linear-gradient(#0052d9, #0052d9);
  }
  .hoverShow div {
    color: #000;
    background: rgba(255, 255, 255, 1);
    &:hover {
      opacity: 0.8;
    }
  }
}
</style>

